import { z } from 'zod';
/** Payload fuer PUT /api/admin/zone-access/:mapId/:zoneId. */
export const zoneAccessUpdateSchema = z.object({
    userIds: z.array(z.string().min(1).max(64)).max(1000),
});
//# sourceMappingURL=zoneAccessSchema.js.map